

















import {Component, Mixins} from 'vue-mixin-decorator';
import {getModule} from 'vuex-module-decorators';
import {Inject} from 'inversify-props';

import {Notify} from '@/utils/Notify';

import {IApiService} from '@/services/IApi.service';

import {ApiStore} from '@/store/Api.store';

import {BaseComponent} from '@/mixins/BaseComponent';

@Component({
  components: {},
})
export default class GatewayUnreachableBanner extends Mixins<BaseComponent>(BaseComponent) {
  @Inject(Symbol.for('IApiService'))
  private apiService!: IApiService;

  private apiStore: ApiStore = getModule(ApiStore, this.$store);

  private remote: string = '';

  private dialogVisible: boolean = false;

  private applyIpChange: boolean = false;
  private refreshing: boolean = false;

  private mounted() {
    if (this.apiStore.Remote) {
      this.remote = this.apiStore.Remote;
    }
  }

  private async refresh() {
    this.refreshing = true;

    if (await this.apiService.check()) {
      this.$router.go(0);
    } else {
      Notify.Error(this.logger, `Could not contact gateway at address '${this.remote}'`);
    }

    this.refreshing = false;
  }

  private async apply() {
    this.logger.debug(`Setting API IP to '${this.remote}'`);
    this.apiStore.setRemote(this.remote);

    try {
      this.logger.debug(`Checking API access...`);
      this.applyIpChange = true;
      if (await this.apiService.check(1000)) {
        this.logger.debug(`API available`);
        this.dialogVisible = false;
      } else {
        this.logger.debug(`Could not contact API`);
        Notify.Error(this.logger, `Could not contact gateway at address '${this.remote}'`);
      }
    } catch (error) {
      Notify.Error(this.logger, `An error occurred when checking gateway access`, error);
    } finally {
      this.applyIpChange = false;
    }
  }
}
